import styled from "@emotion/styled";
import { createFocusRingStyles } from "../../../util/createFocusRingStyles";
import { withFocusToggleClassName } from "../../../util/withFocusClassName";
import { TextInputRootBase } from "./TextInputRootBase";
import {
    TextInputRootBoxProps,
    formInputTheme,
    getBackgroundColor,
    getBorderColor,
    getBorderWidth,
} from "./formInputTheme";

export const TextInputRootBox = withFocusToggleClassName(styled(TextInputRootBase)<TextInputRootBoxProps>`
    border-style: solid;
    border-width: ${getBorderWidth}px;
    border-color: ${getBorderColor};
    border-radius: ${({ themeMode }) => formInputTheme.borderRadius(themeMode)};
    background-color: ${getBackgroundColor};

    ${({ themeMode, validationState }) =>
        formInputTheme.focusRing.enabled(themeMode) &&
        createFocusRingStyles({
            gap: formInputTheme.focusRing.offset(themeMode),
            componentBorderWidth:
                validationState === "error"
                    ? formInputTheme.borderWidth.error(themeMode)
                    : formInputTheme.borderWidth.rest(themeMode),
            componentRadius: formInputTheme.borderRadius(themeMode),
            theme: themeMode,
            focusSelector: ":focus-within",
        })}

    & input {
        outline: none;
    }
`);
